import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { RestSchemas, useRestClient } from '@/contexts/QueryProvider'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { toast } from 'sonner'
import { ApplicationSettingForm } from '../../Forms/ApplicationSettingForm'
import { useCurrentApplication } from '../../useCurrentApplication'

type ApplicationSetting = RestSchemas['Messages.Applications.ApplicationSetting']

export function RowActionsMenu({ row }: { row: ApplicationSetting }) {
  const { applicationId } = useCurrentApplication()
  const { deleteApplicationsApiDeleteApplicationSetting, getApplicationsApiGetApplicationSettings } = useRestClient()

  const { mutate: deleteSetting } = deleteApplicationsApiDeleteApplicationSetting.useMutation(undefined, {
    onSuccess: () => {
      getApplicationsApiGetApplicationSettings.invalidateQueries({
        parameters: {
          query: { applicationId },
        },
      })
      toast.success('Application setting deleted')
    },
    onError: () => {
      toast.error('Failed to delete application setting')
    },
  })

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="size-8 rounded-full">
          <IconMenuOutline size={16} />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <ApplicationSettingForm
          selectedSetting={row}
          sheetTitle="Edit setting"
          sheetTrigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Edit setting</DropdownMenuItem>}
        />
        <ConfirmDialog
          title="Delete setting"
          description="Are you sure you want to delete this setting?"
          onConfirm={() =>
            deleteSetting({
              query: { applicationId, key: row.key ?? '' },
            })
          }
          trigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()} disabled={!row.key}>
              Delete setting
            </DropdownMenuItem>
          }
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
